// these functions won't run at once, but will be available from anywhere via this.functionName
export const staticFunctions = {
    sparedFunction() {
        console.log("spareFunction executed");
    },
    anotherSparedFunction(arg) {
        console.log(`anotherSpareFunction executed with args: ${arg}`);
    },
    isInViewPort(targetItem) {
        let coords = targetItem.getBoundingClientRect();
        let windowHeight = document.documentElement.clientHeight;
        let topVisible = coords.top > 0 && coords.top < windowHeight;
        let bottomVisible = coords.bottom < windowHeight && coords.bottom > 0;
        return topVisible || bottomVisible;
    },
    isIE() {
        let ua = window.navigator.userAgent; //Check the userAgent property of the window.navigator object
        let msie = ua.indexOf("MSIE"); // IE 10 or older
        let trident = ua.indexOf("Trident/"); //IE 11
    
        return (msie > 0 || trident > 0);
    }
};


// WEBPACK FOOTER //
// ./assets/js/modules/static.js